"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("./colors");
const common_1 = require("./common");
const verse_logo_png_1 = __importDefault(require("../../static/verse_logo.png"));
const verse = {
    logo: verse_logo_png_1.default,
    palette: {
        text: {
            default: colors_1.colors.white,
            secondary: colors_1.colors.shade70,
            exclusive: colors_1.colors.exclusive100,
            hover: colors_1.colors.verseBlue,
        },
        menu: {
            text: {
                default: colors_1.colors.white,
                hover: colors_1.colors.white,
                selected: colors_1.colors.white,
            },
            icon: {
                default: colors_1.colors.white,
                selected: colors_1.colors.primaryBlue100,
            },
        },
        background: {
            default: colors_1.colors.black,
            secondary: colors_1.colors.verseNavyBlue,
            tertiary: colors_1.colors.verseAlmostBlack,
            primary: common_1.primaryBackground,
            overlay: 'rgba(0, 0, 0, 0.7)',
            card: colors_1.colors.verseCardColor,
        },
        border: {
            default: colors_1.colors.shade50,
            secondary: colors_1.colors.shade30,
        },
        input: {
            text: {
                default: colors_1.colors.white,
                hover: colors_1.colors.shade60,
                active: colors_1.colors.shade60,
                disabled: colors_1.colors.shade50,
            },
            background: {
                default: colors_1.colors.shade10,
                hover: colors_1.colors.shade10,
                active: colors_1.colors.shade10,
                disabled: colors_1.colors.shade20,
            },
            border: {
                default: colors_1.colors.shade50,
                hover: colors_1.colors.shade70,
                active: colors_1.colors.primaryBlue100,
                disabled: colors_1.colors.shade30,
                error: colors_1.colors.red100,
            },
        },
        buttons: {
            standard: {
                background: {
                    default: '#2D3547',
                    hover: '#45516D',
                    active: '#2D3547',
                    disabled: colors_1.colors.shade30,
                },
                border: {
                    default: '#586B92',
                    hover: '#586B92',
                    active: '#586B92',
                },
            },
        },
        carousel: {
            indicators: {
                default: colors_1.colors.shade50,
                active: colors_1.colors.primaryBlue100,
            },
        },
        hero: {
            icon: {
                default: colors_1.colors.primaryBlue100,
            },
        },
    },
    border: common_1.border,
    spacing: common_1.spacing,
    shadows: common_1.shadows,
};
exports.default = verse;
//# sourceMappingURL=verse.js.map